import { endpoints } from '../endpoints';
import { getFileNameFromHeader, parseFile, parseResponse } from '../parseResponse';
import { getHeader } from './generalApi';

export async function getDiggingPermit(caseNumber, srid) {
  return fetch(`${endpoints.diggingPermit}/?caseNumber=${encodeURIComponent(caseNumber)}&srid=${srid}`, {
    ...(await getHeader('GET'))
  }).then(parseResponse);
}

export async function getTAPlan(caseNumber, srid) {
  return fetch(`${endpoints.taplan}/?caseNumber=${encodeURIComponent(caseNumber)}&srid=${srid}`, {
    ...(await getHeader('GET'))
  }).then(parseResponse);
}

export async function getLeasehold(caseNumber, srid) {
  return fetch(`${endpoints.leasehold}/?caseNumber=${encodeURIComponent(caseNumber)}&srid=${srid}`, {
    ...(await getHeader('GET'))
  }).then(parseResponse);
}

export async function createDiggingPermit(diggingPermit) {
  return fetch(`${endpoints.diggingPermit}`, {
    ...(await getHeader('POST')),
    body: JSON.stringify(diggingPermit)
  }).then(parseResponse);
}

export async function createTAPlan(taPlan) {
  return fetch(`${endpoints.taplan}`, {
    ...(await getHeader('POST')),
    body: JSON.stringify(taPlan)
  }).then(parseResponse);
}

export async function createLeasehold(leasehold) {
  return fetch(`${endpoints.leasehold}`, {
    ...(await getHeader('POST')),
    body: JSON.stringify(leasehold)
  }).then(parseResponse);
}

export async function updateDiggingPermit(diggingPermit) {
  return fetch(`${endpoints.diggingPermit}`, {
    ...(await getHeader('PUT')),
    body: JSON.stringify(diggingPermit)
  }).then(parseResponse);
}

export async function updateTAPlan(taPlan) {
  return fetch(`${endpoints.taplan}`, {
    ...(await getHeader('PUT')),
    body: JSON.stringify(taPlan)
  }).then(parseResponse);
}

export async function updateLeasehold(leasehold) {
  return fetch(`${endpoints.leasehold}`, {
    ...(await getHeader('PUT')),
    body: JSON.stringify(leasehold)
  }).then(parseResponse);
}

export async function prolongDiggingPermit(gid, prolongedToDate, prolongedToTime, prolongedReason) {
  return fetch(`${endpoints.diggingPermit}/prolong`, {
    ...(await getHeader('PUT')),
    body: JSON.stringify({ gid, prolongedToDate, prolongedToTime, prolongedReason })
  }).then(parseResponse);
}

export async function prolongTAPlan(gid, prolongedToDate, prolongedToTime, prolongedReason) {
  return fetch(`${endpoints.taplan}/prolong`, {
    ...(await getHeader('PUT')),
    body: JSON.stringify({ gid, prolongedToDate, prolongedToTime, prolongedReason })
  }).then(parseResponse);
}

export async function downloadDiggingPermitPdf(gid) {
  return fetch(`${endpoints.diggingPermit}/pdfreport/${gid}`, {
    ...(await getHeader('GET'))
  }).then(response => parseFile(response, getFileNameFromHeader(response)));
}

export async function downloadTAPlanPdf(gid) {
  return fetch(`${endpoints.taplan}/pdfreport/${gid}`, {
    ...(await getHeader('GET'))
  }).then(response => parseFile(response, getFileNameFromHeader(response)));
}

export async function downloadLeaseholdPdf(gid) {
  return fetch(`${endpoints.leasehold}/pdfreport/${gid}`, {
    ...(await getHeader('GET'))
  }).then(response => parseFile(response, getFileNameFromHeader(response)));
}

export async function setDiggingPermitToDone(gid, doneValues) {
  return fetch(`${endpoints.diggingPermit}/UpdateStatusToWorkDone`, {
    ...(await getHeader('PUT')),
    body: JSON.stringify({ gid, Items: doneValues })
  }).then(parseResponse);
}

export async function removeConnectionToApplication(request) {
  return fetch(`${endpoints.connection}/PutDisconnectionFromApplication`, {
    ...(await getHeader('PUT')),
    body: JSON.stringify(request)
  }).then(parseResponse);
}

export async function createConnectionToApplication(request) {
  return fetch(`${endpoints.connection}/PutConnectionToApplication`, {
    ...(await getHeader('PUT')),
    body: JSON.stringify(request)
  }).then(parseResponse);
}
